export const getFrontendDomain = () => {
	
	const { hostname } = window.location;
	
	if(process.env.GATSBY_DEV_ENV === 'prod') {
		if (hostname.endsWith('.vn')) {
			return 'https://letscelebrate.vn/';
		}
		if (hostname.endsWith('.io')) {
			return 'https://letscelebrate.io/';
		}
		
		return 'https://letscelebrate.vn/';
	}
	
	return process.env.GATSBY_FRONTEND_URL;
};

export const checkGlobalDomain = () => {
	
	const { hostname } = window.location;
	
	if(process.env.GATSBY_DEV_ENV === 'prod') {
		if (hostname.endsWith('.io')) {
			return true;
		}
	}
	
	return false;
};
